const drawerActions = {
    SHOW_DRAWER: 'SHOW_DRAWER',
    HIDE_DRAWER: 'HIDE_DRAWER',
    ASTK_TO_CLOSE: 'ASTK_TO_CLOSE',

    openDrawer: payload => ({
        type: drawerActions.SHOW_DRAWER,
        payload,
    }),
    closeDrawer: () => ({
        type: drawerActions.HIDE_DRAWER,
    }),
    askToClose: bool => ({
        type: drawerActions.ASTK_TO_CLOSE,
        payload: { bool },
    }),
}

export default drawerActions
